import React from "react";

const EmptyPage = (props) => {
  return <div>この機能はまだ実装されていません。</div>;
};

export default EmptyPage;
